import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import noop from 'lodash/noop';
import Button from 'yoda-core-components/lib/components/Button';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import AddToCartInterstitial from 'yoda-checkout-components/lib/components/AddToCartInterstitial/AddToCartInterstitial';
import StockAlertSignUpModal from 'yoda-site-components/lib/components/StockAlertSignUpModal/StockAlertSignUpModalConnect';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import CustomAddToCart from '../../../common/CustomAddToCart/CustomAddToCart';
import * as styles from './AddToCart.css';

const cx = classNames.bind(styles);
class AddToCart extends Component {
    static propTypes = {
        listId: PropTypes.string.isRequired,
        uuid: PropTypes.string.isRequired,
        itemId: PropTypes.string.isRequired,
        PDPURL: PropTypes.string.isRequired,
        LoaderAction: PropTypes.objectOf(PropTypes.object).isRequired,
        pageEvent: PropTypes.func,
        addToCartActions: PropTypes.objectOf(PropTypes.object).isRequired,
        addToCart: PropTypes.objectOf(PropTypes.object).isRequired,
        featureFlags: PropTypes.objectOf(PropTypes.object).isRequired,
        ppId: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        SKUList: PropTypes.arrayOf.isRequired,
        editItem: PropTypes.objectOf(PropTypes.object).isRequired,
        vdata: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        quantity: PropTypes.number,
        isOOSAlert: PropTypes.bool,
        messagesTexts: PropTypes.objectOf(PropTypes.object),
        showTopMessage: PropTypes.func,
        myAlertsProps: PropTypes.object,
        isOutOfStock: PropTypes.bool,
    };

    static defaultProps = {
        quantity: 1,
        pageEvent: noop,
        isOOSAlert: false,
        messagesTexts: {},
        showTopMessage: noop,
        myAlertsProps: {},
        isOutOfStock: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            showStockAlertSignupModal: false,
        };
    }

    componentDidUpdate(prevProps) {
        const {
            messagesTexts,
            myAlertsProps: { isSuccess, isFailuire },
        } = this.props;
        const { myAlertsProps: myAlertsPrevProps } = prevProps;
        if (
            isSuccess !== myAlertsPrevProps.isSuccess ||
            isFailuire !== myAlertsPrevProps.isFailuire
        ) {
            let messageType = '';
            let stockAlertMessage = '';
            if (isSuccess) {
                messageType = 'success';
                stockAlertMessage = messagesTexts.stockAlertSignUpModal.successMessage;
            } else if (isFailuire) {
                messageType = 'error';
                stockAlertMessage = messagesTexts.stockAlertSignUpModal.errorMessage;
            }
            if (!isEmpty(messageType)) {
                this.props.showTopMessage(messageType, stockAlertMessage);
            }
        }
    }

    removeLoader = () => {
        /* istanbul ignore next */
        this.props.LoaderAction.removeLoader();
    };

    closeCartModal = () => {
        /* istanbul ignore next */
        const analyticsData = {
            trackEvent: 'digitalDataReady',
            pageName: 'list landing page',
        };
        this.props.pageEvent(analyticsData);
        this.props.addToCartActions.closeCartModal();
    };

    addToCartClicked = (cartAnalytics) => {
        const { isOOSAlert } = this.props;
        if (isOOSAlert) {
            this.setState({ showStockAlertSignupModal: true });
        }
        if (cartAnalytics) {
            LocalStorage.removeData('AddToCartAnalytics');
        } else {
            LocalStorage.setData('AddToCartAnalytics', true);
        }
    };

    closeStockAlertSignupModal = () => {
        this.setState({ showStockAlertSignupModal: false });
    };

    selectOption = () => {
        const { type, vdata } = this.props;
        if (type === 'REGULAR' && !vdata) {
            this.props.editItem();
        } else {
            const url = this.props.PDPURL.split('.com');
            window.location.assign(url[1]);
        }
    };

    render() {
        const {
            listId,
            uuid,
            itemId,
            addToCartActions,
            LoaderAction,
            addToCart,
            featureFlags,
            ppId,
            status,
            isOOSAlert,
            SKUList,
            quantity,
            messagesTexts,
            isOutOfStock,
        } = this.props;
        const { showStockAlertSignupModal } = this.state;
        const zipCode = find(SKUList, (sku) => sku.type === 'zipCode');
        const analyticsData = {};
        const productDetails = {
            data: [
                {
                    skuId: itemId,
                    ppId,
                    quantity: quantity || 1,
                    deliveryOption: {
                        type: 'HOME',
                        selected: true,
                        zipcode: zipCode && zipCode.value,
                    },
                },
            ],
        };
        return (
            <div className={`${cx('addToCartWrapper')} ${dt(['mb-4'])}`}>
                {status === 'ADD_TO_CART' && (
                    <CustomAddToCart
                        productDetails={productDetails}
                        buttonTheme={cx('customAddToCart')}
                        addToCartActions={addToCartActions}
                        LoaderAction={LoaderAction}
                        addToCart={addToCart}
                        analyticsData={analyticsData}
                        listId={listId}
                        productId={uuid}
                        itemId={itemId}
                        onCloseAddToCart={this.closeCartModal}
                        addToCartClicked={this.addToCartClicked}
                        featureFlags={featureFlags}
                        isOOSAlert={isOOSAlert}
                        messagesTexts={messagesTexts}
                        isOutOfStock={isOutOfStock}
                    />
                )}
                {showStockAlertSignupModal && (
                    <StockAlertSignUpModal
                        onTooltipClose={this.closeStockAlertSignupModal}
                        skuId={itemId}
                    />
                )}
                {status === 'SELECT_SKU_OPTIONS' && (
                    <div>
                        <Button
                            automationId="product-card-item-button"
                            size="Md"
                            buttonType="Secondary"
                            className={dt([
                                'w-[200px]',
                                'smOnly:w-full',
                                'flex',
                                'flex-col',
                                'justify-center',
                                'gap-1',
                            ])}
                            onClick={this.selectOption}
                        >
                            Select Options
                        </Button>
                    </div>
                )}
                {status === 'SELECT_SKU_OPTIONS' &&
                    addToCart &&
                    addToCart.isAddToCartSuccess &&
                    addToCart.from &&
                    addToCart.ppId === ppId && (
                        <AddToCartInterstitial
                            key={ppId + itemId}
                            sku={addToCart.skuId}
                            showAddToCart={addToCart.isAddToCartSuccess}
                            ppId={addToCart.ppId}
                            onCloseAddToCart={this.closeCartModal}
                            removeLoader={this.removeLoader}
                        />
                    )}
            </div>
        );
    }
}

export default AddToCart;
